/* eslint-disable max-len */
export const ABOUT =
  "I'm a recently-graduated PhD candidate in Computer Science. In my thesis, I primarily worked on semi-automated tools that help people manage their personal cloud storage (ex. Google Drive). I'm currently wrapping up some of my other research on human-computer interaction problems for machine learning.";

export const INTERESTS = "If you want to start a conversation, try these: ";

export const NEWS = [
  "Our paper on summarizing sets of related recommendations in cloud storage has been accepted to UIST 2022. Looking forward to traveling to Bend, Oregon!",
  "I successfully defended my PhD! Many thanks to my advisers and my committee for their support on this milestone",
  "My dissertation defense is scheduled for April 27th--an exciting end to a long journey",
  "Our paper on instructions for annotator rationales was accepted to NAACL 2022! Congratulations to Jamar Sullivan on his first-ever first-author paper",
];

export const PUBLICATIONS = [
  {
    link: "../public/assets/summarize_final.pdf",
    title:
    "Summarizing Sets of Related ML-Driven Recommendations for Improving File Management in Cloud Storage",
    authors:
    "Will Brackenbury, Kyle Chard, Aaron J. Elmore, Blase Ur",
    journal: "UIST 2022",
  },

  {
    title:
      "Explaining Why: How Instructions and User Interfaces Impact Annotator Rationales When Labeling Text Data",
    authors:
      "Jamar L. Sullivan Jr., Will Brackenbury, Andrew McNutt, Kevin Bryson, Kwam Byll, Yuxin Chen, Michael L. Littman, Chenhao Tan, Blase Ur",
    journal: "NAACL 2022",
  },

  {
    link: "../public/assets/kondocloud_final.pdf",
    title:
      "KondoCloud: Improving Information Management in Cloud Storage via Recommendations Based on File Similarity",
    authors:
      "Will Brackenbury, Andrew M. McNutt, Kyle Chard, Aaron J. Elmore, Blase Ur",
    journal: "UIST 2021",
  },

  {
    link: "../public/assets/flock_final.pdf",
    title:
      "Files of a Feather Flock Together? Measuring and Modeling How Users Perceive File Similarity in Cloud Storage",
    authors:
      "Will Brackenbury, Galen Harrison, Kyle Chard, Aaron J. Elmore, Blase Ur",
    journal: "SIGIR 2021",
  },

  {
    link: "../public/assets/chi19-ifttt-cameraready.pdf",
    title: "How Users Interpret Bugs in Trigger-Action Programming",
    authors:
      "Will Brackenbury, Abhimanyu Deora, Jillian Ritchey, Jason Vallee, Weijia He, Guan Wang, Michael L. Littman, Blase Ur",
    journal: "CHI 2019",
  },
  {
    link: "../public/assets/hilda18.pdf",
    title: "Draining the Data Swamp: A Similarity-based Approach",
    authors:
      "Will Brackenbury, Rui Liu, Mainack Mondal, Aaron J. Elmore, Blase Ur, Kyle Chard, Michael J. Franklin",
    journal: "HILDA 2018",
  },
  {
    link: "../public/assets/p2038-shang.pdf",
    title: "CYADB: A Database that Covers Your Ask",
    authors:
      "Zechao Shang, Will Brackenbury, Aaron J. Elmore, Michael J. Franklin",
    journal: "VLDB (Demo) 2018",
  },
  {
    link: "../public/assets/p2098-kesslerfaulkner.pdf",
    title: "k-Regret Queries with Nonlinear Utilities",
    authors:
      "Taylor Kessler Faulkner*, Will Brackenbury*, Ashwin Lall (*co-first authors)",
    journal: "VLDB 2015",
  },
];
